import React, { useState } from "react";
import { Typography } from "@material-tailwind/react";

const TableRowWithShowMore = ({ data }) => {
  const [showFullText, setShowFullText] = useState(false);

  const toggleShowMore = () => {
    setShowFullText((prevState) => !prevState);
  };

  return (
    <>
      <Typography variant="small" color="blue-gray" className="font-normal">
        {showFullText ? data : `${data.slice(0, 40)}...`}
      </Typography>
      <button
        type="button"
        onClick={toggleShowMore}
        className="text-xs hover:text-opacity-70 text-blue-700"
      >
        {showFullText ? "Show Less" : "Show More"}
      </button>
    </>
  );
};

export default TableRowWithShowMore;
